import { render, staticRenderFns } from "./fivesTableCell.vue?vue&type=template&id=131f6cc5&"
import script from "./fivesTableCell.vue?vue&type=script&lang=js&"
export * from "./fivesTableCell.vue?vue&type=script&lang=js&"
import style0 from "./fivesTableCell.vue?vue&type=style&index=0&id=131f6cc5&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports